import React from 'react';
import { SaveButton, Toolbar } from 'react-admin';

export default ({ pristine, ...props }) => (
    <Toolbar {...props}>
        <SaveButton disabled={pristine} />
    </Toolbar>
);
